require('./src/global.css');

exports.wrapPageElement = require(`./src/wrap-page`).default;
